import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-excel-view',
  templateUrl: './excel-view.component.html',
  styleUrls: ['./excel-view.component.scss']
})
export class ExcelViewComponent implements OnInit {

  data = [{
    id: 1,
    name: 'sampat',
    cast: 'gurjar',
    location: "Udaipur",
  },
  {
    id: 2,
    name: 'sampat',
    cast: 'gurjar',
    location: "Udaipur"

  },
  {
    id: 3,
    name: 'sampat',
    cast: 'gurjar',
    location: "Udaipur"

  },
  {
    id: 4,
    name: 'sampat',
    cast: 'gurjar',
    location: "Udaipur"

  },]

  Object = Object

  constructor() { }

  ngOnInit(): void {
    console.log(this.data)
    let ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data);
    let wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    console.log(wb)
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    console.log(excelBuffer)
    // this.saveExcelFile(excelBuffer, 'same');
  }
  valueChanged(ev) {
    console.log(this.data)
  }

}
